import { useCurrentFrame, useVideoConfig } from 'remotion'
import { COMPONENTS } from '../components'
import { useFadeOpacity } from '../fades'
import type { ComponentItem } from '../types'

/** A registry component, positioned and faded like any other item. */
export function ComponentLayer({ item }: { item: ComponentItem }) {
  const frame = useCurrentFrame()
  const { fps, durationInFrames } = useVideoConfig()
  const opacity = useFadeOpacity({
    frame,
    fps,
    durationInFrames,
    fadeInDurationInSeconds: item.fadeInDurationInSeconds,
    fadeOutDurationInSeconds: item.fadeOutDurationInSeconds,
    opacity: item.opacity,
  })
  const Component = COMPONENTS[item.componentId].Component as React.FC<{
    item: ComponentItem
  }>

  return (
    <div
      style={{
        position: 'absolute',
        left: item.left,
        top: item.top,
        width: item.width,
        height: item.height,
        opacity,
        transform: `rotate(${item.rotation}deg)`,
        overflow: 'hidden',
      }}
    >
      <Component item={item} />
    </div>
  )
}
